import { defaultDateFormatter, TableField } from "../../table-field";
/**
 * ug, processo, assunto, dt publicação, decisão, parecer mp, multa, processo íntegra
 */
export const tableFieldsDecisoes: TableField[] = [
  {
    key: "ug",
    label: "Unidade Gestora",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "cod_processo",
    label: "Processo",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: "align-center",
    sortable: true,
  },
  {
    key: "assunto",
    label: "Assunto",
    tdClass: ["align-middle", "quebrarPorPalavra"],
    thClass: ["align-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "dt_publicacao_DOE",
    label: "Data de Publicação",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["align-center", "quebrarPorPalavraHard"],
    sortable: true,
    formatter: defaultDateFormatter,
  },
  {
    key: "actions",
    label: "Anexos",
    tdClass: ["align-middle", "col-actions"],
    thClass: "text-center",
    sortable: false,
  },
];
